/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { Gavel } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j10-s03-aprovador-decidir-aplicar-solicitacao';
export function DecidirAplicarSolicitacaoPage() {
  const [e, setE] = useState<any>();
  const [ocupado, setO] = useState(false);
  async function call(path: string, corpo?: unknown) {
    setO(true);
    try {
      const r = await chamarApi<any>(NS + path, {
        metodo: path === '/state' ? 'GET' : 'POST',
        corpo,
      });
      setE(r.state);
    } finally {
      setO(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!e) return <main role="status">Carregando decisões…</main>;
  return (
    <main className="w-full min-w-0 space-y-5 overflow-x-hidden">
      <h1 className="text-3xl font-semibold">
        <Gavel className="mr-2 inline" />
        {e.titulo}
      </h1>
      <p>{e.descricao}</p>
      {e.alertas.map((a: any) => (
        <p role="alert" key={a.codigo}>
          {a.mensagem} <code>{a.codigo}</code>
        </p>
      ))}
      {e.vazio && <p>Nenhum pedido aguarda decisão.</p>}
      {e.pedidos.map((p: any) => (
        <article className="space-y-3 rounded-md border p-4" key={p.id}>
          <h2 className="font-semibold">
            {p.protocolo} · {p.status} · versão {p.versao}
          </h2>
          <p>
            Fila {p.fila} · alçada {p.alcada}
          </p>
          <p>Registro vigente: {p.observacao_oficial}</p>
          <p>Mudança instruída: {p.descricao}</p>
          {p.status === 'INSTRUIDA' && (
            <div className="flex flex-wrap gap-2">
              <Button
                disabled={ocupado}
                variant="outline"
                onClick={() =>
                  void call('/verbs/decidir_aplicar', {
                    solicitacaoId: p.id,
                    versaoEsperada: p.versao - 1,
                    decisao: 'APROVADA',
                    fundamento: 'Tentativa controlada para comprovar conflito da versão instruída.',
                    chaveIdempotencia: crypto.randomUUID(),
                  })
                }
              >
                Provar conflito de versão
              </Button>
              <Button
                disabled={ocupado}
                onClick={() =>
                  void call('/verbs/decidir_aplicar', {
                    solicitacaoId: p.id,
                    versaoEsperada: p.versao,
                    decisao: 'APROVADA',
                    fundamento:
                      'A instrução está completa, pertence à alçada DTP técnica e o comprovante sustenta a alteração requerida.',
                    chaveIdempotencia: crypto.randomUUID(),
                  })
                }
              >
                Aprovar e aplicar
              </Button>
              <Button
                disabled={ocupado}
                variant="outline"
                onClick={() =>
                  void call('/verbs/decidir_aplicar', {
                    solicitacaoId: p.id,
                    versaoEsperada: p.versao,
                    decisao: 'REJEITADA',
                    fundamento:
                      'Os elementos apresentados não sustentam a alteração formal solicitada no registro oficial.',
                    chaveIdempotencia: crypto.randomUUID(),
                  })
                }
              >
                Rejeitar sem aplicar
              </Button>
            </div>
          )}
          {p.decisao && (
            <section>
              <p>
                Decisão {p.decisao.decisao} por {p.decisao.autor_id}
              </p>
              <p>{p.decisao.fundamento}</p>
              <p>Efeito: {p.efeito ? 'aplicado uma vez' : 'nenhum efeito oficial'}</p>
              <Button
                disabled={ocupado}
                variant="outline"
                onClick={() =>
                  void call('/verbs/decidir_aplicar', {
                    solicitacaoId: p.id,
                    versaoEsperada: p.decisao.versao_decidida,
                    decisao: p.decisao.decisao,
                    fundamento: p.decisao.fundamento,
                    chaveIdempotencia: p.decisao.chave_idempotencia,
                  })
                }
              >
                Repetir decisão idempotente
              </Button>
            </section>
          )}
          <code className="break-all">{p.id}</code>
        </article>
      ))}
      {e.resultado && <p role="status">Operação persistida: {JSON.stringify(e.resultado)}</p>}
    </main>
  );
}
